// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "checkbox_notActive-1dArr";
var _5 = "wrapper-2hBLS";
var _6 = "wrapper_inDialog-1o-1r";
var _7 = "wrapper_solid-13Vdt";
var _8 = "wrapper_outline-5aNYi";
var _9 = "wrapper_active-BgdcB";
var _a = "head-d5Bri";
var _b = "header-1cGZL";
var _c = "switcher-2zTXR";
var _d = "money-2WhhU";
var _e = "money_opened-txb5f";
var _f = "item_money-1p1na";
var _10 = "desc-2-S6S";
var _11 = "item-34Xw4";
var _12 = "itemprice-3lq--";
var _13 = "checkbox_checked-3iOIK";
var _14 = "checkbox-1sP2e";
var _15 = "checkbox__label-1xhgp";
var _16 = "label__from-qG-n1";
var _17 = "not_selected-3BSOF";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "checkbox_notActive", _5 as "wrapper", _6 as "wrapper_inDialog", _7 as "wrapper_solid", _8 as "wrapper_outline", _9 as "wrapper_active", _a as "head", _b as "header", _c as "switcher", _d as "money", _e as "money_opened", _f as "item_money", _10 as "desc", _11 as "item", _12 as "itemprice", _13 as "checkbox_checked", _14 as "checkbox", _15 as "checkbox__label", _16 as "label__from", _17 as "not_selected" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "checkbox_notActive": _4, "wrapper": _5, "wrapper_inDialog": _6, "wrapper_solid": _7, "wrapper_outline": _8, "wrapper_active": _9, "head": _a, "header": _b, "switcher": _c, "money": _d, "money_opened": _e, "item_money": _f, "desc": _10, "item": _11, "itemprice": _12, "checkbox_checked": _13, "checkbox": _14, "checkbox__label": _15, "label__from": _16, "not_selected": _17 }
